
import { isValid, parse } from "date-fns";

type ParseDateInput = string | Date | null | undefined;

const supportedDateFormats = [
  "yyyy-MM-dd",
  "yyyy-MM-dd HH:mm:ss",
  "yyyy-MM-dd'T'HH:mm:ss",
] as const;

// Helper to parse date string to Date object without timezone issues
export const parseDate = (dateInput: ParseDateInput): Date | null => {
  if (!dateInput) return null;

  if (dateInput instanceof Date) {
    return isValid(dateInput) ? dateInput : null;
  }

  const dateStr = dateInput.trim();
  if (!dateStr) return null;

  for (const fmt of supportedDateFormats) {
    try {
      const parsed = parse(dateStr, fmt, new Date());
      if (isValid(parsed)) return parsed;
    } catch {
      // Continue to next format
    }
  }

  // If no format matched, try extracting just the date part if it contains 'T'
  if (dateStr.includes("T")) {
    const dateOnly = dateStr.split("T")[0];
    try {
      const parsed = parse(dateOnly, "yyyy-MM-dd", new Date());
      if (isValid(parsed)) return parsed;
    } catch {
      // Ignore
    }
  }

  return null;
};